import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/mergeMap';
import { INITIALIZE_APP_PROPS } from '../../state/actions/app';
import { fetchEstimationConfig } from '../../state/actions/estimation-config';
import { fetchTimeTrackingOptions } from '../../state/actions/time-tracking-options';
import { velocityDataFetch } from '../../state/actions/velocity-data-fetch';
import type { ActionsObservable } from '../../state/types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable) =>
	action$.ofType(INITIALIZE_APP_PROPS).flatMap(() => {
		if (__SERVER__) {
			return Observable.from([]);
		}

		const initalAppActions = [
			fetchEstimationConfig(),
			velocityDataFetch(),
			fetchTimeTrackingOptions(),
		];

		return Observable.from(initalAppActions);
	});
